import { render, staticRenderFns } from "./Objekti.vue?vue&type=template&id=be90d37e&scoped=true&"
import script from "./Objekti.vue?vue&type=script&lang=ts&"
export * from "./Objekti.vue?vue&type=script&lang=ts&"
import style0 from "./Objekti.vue?vue&type=style&index=0&id=be90d37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be90d37e",
  null
  
)

export default component.exports